import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Injectable} from "@angular/core";
import { ProductService } from "../../product/product-service/product.service";
import { InventoryService } from "../../../service/inventory.service";

@Injectable({ providedIn: 'root' })
export class StockItemDetailResolver implements Resolve<any> {

  constructor(private inventoryService: InventoryService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.paramMap.get('id');
    return this.inventoryService.getStockById(id!);
  }
}
